import PropTypes from 'prop-types';
import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './BasicInput.scss';

class BasicInput extends React.Component {
  constructor () {
    super(...arguments);
    this.state = {
      invalidValue: false
    };
  }

  static propTypes = {
    dataAt: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    validator: PropTypes.func,
  };

  static defaultProps = {
    dataAt: "",
    placeholder: "",
    value: "",
    onChange: ()=>{},
    onBlur: ()=>{},
    onFocus: ()=>{},
    validator: ()=>true,
  };


  handleChange (e) {
    const value = e.target.value;
    this.props.onChange(value);
  }

  handleFocus (e) {
    this.props.onFocus(e);
    this.setState(()=>({invalidValue: false}));
  }

  handleBlur (e) {
    this.props.onBlur(e);
    const value = e.target.value;
    if (this.props.validator(value)) {
      this.setState(()=>({invalidValue: false}));
    } else {
      // TODO: handle error
      this.setState(()=>({invalidValue: true}));
    }
  }

  render() {
    return (
      <div styleName="inputContainer">
        <input styleName="basicInput" data-at={this.props.dataAt} value={this.props.value} onBlur={this.handleBlur.bind(this)} onFocus={this.handleFocus.bind(this)} type={"text"} placeholder={this.props.placeholder} onChange={this.handleChange.bind(this)} />
        {this.state.invalidValue && this.props.errorMessage && <span styleName="inputError">{this.props.errorMessage}</span>}
      </div>
    );
  }
}

// export default BasicInput;
export default CSSModules(styles, {allowMultiple: true})(BasicInput);



// WEBPACK FOOTER //
// ./src/components/common/Input/BasicInput.js